import keyBy from 'lodash/keyBy';

import {dataGroupsClient} from 'common/report/queries/app-api/data-groups-client';
import {DataGroup} from 'common/widgets/data-group-selector/types';

import {Store} from './store';

export const dataGroupStore = new Store<DataGroup>({
  apiClient: dataGroupsClient,
  defaultValue: {},
  name: `data-groups`,
  transform: {
    index: (response) => keyBy(response, `groupID`),
  },
});
